import { useEffect, useRef, useState } from "react";

/** Fires once when the element enters the viewport. */
export function useInView(options = { threshold: 0.25 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        obs.disconnect();
      }
    }, options);
    obs.observe(node);
    return () => obs.disconnect();
  }, [options]);
  return [ref, visible];
}
